import {dataRegister} from "./dataRegister";
import {EventEmitter} from "./eventRegister"
import Pusher from 'pusher-js';

const pusher = new Pusher('5688dc5fc1fa3c9399ee', {
    cluster: 'ap2',
    forceTLS: true
});

const channel = pusher.subscribe('saleschannel-carousel');
const id = window.crypto.getRandomValues(new Uint32Array(1))[0].toString(16);
channel.bind(id, function(data) {
    try {
        if(data.percent){
            carouselRegister.setPercentage(data.percent);
        }
    }catch (e) {}
});

class carouselRegister {

    static carousel = null;
    static called = false;
    static block = false;
    static error = false;
    static progress = 0;

    static setCarousel(carousel){
        carouselRegister.carousel = carousel;
        try {
            sessionStorage.setItem('carousel', JSON.stringify(carousel));
        }catch (e) {}
    }

    static setPercentage(percentage){
        if(percentage > carouselRegister.progress || percentage === 0){
            carouselRegister.progress = percentage;
            EventEmitter.emit('carousel-progress', carouselRegister.progress);
        }
    }

    static setError(value){
        carouselRegister.error = value;
        try {
            if(!value){
                EventEmitter.emit('carousel-error', false);
                sessionStorage.removeItem('carousel-error');
            }else{
                EventEmitter.emit('carousel-error', true);
                sessionStorage.setItem('carousel-error', value);
            }
        }catch (e) {}
    }

    static getError(){
        try {
            if(carouselRegister.error){
                return true
            }else if(sessionStorage.getItem('carousel-error')){
                return true;
            }else{
                return false;
            }
        }catch (e) {
            return false;
        }
    }

    static getProgress(){
        return carouselRegister.progress;
    }

    static get(){
        try {
            if(!carouselRegister.called){
                if(carouselRegister.carousel){
                    return carouselRegister.carousel;
                }
                else if(sessionStorage.getItem('carousel')){
                    return JSON.parse(sessionStorage.getItem('carousel'));
                }else{
                    return null;
                }
            }else{
                return null;
            }
        }catch (e) {
            return null;
        }
    }

    static create(data){
        if(!carouselRegister.called && !carouselRegister.get()){
            carouselRegister.setPercentage(0);
            carouselRegister.called = true;
            carouselRegister.setError(false);

            //SET ID
            data.session_id = id;

            dataRegister.createCarousel(data).then((response) => {
                if(!carouselRegister.block){
                    carouselRegister.setCarousel(response);
                    EventEmitter.emit('carousel', response);
                }
                carouselRegister.setError(false);
                carouselRegister.block = false;
                carouselRegister.called = false;
            }, (error) => {
                carouselRegister.setPercentage(0);
                carouselRegister.setError(true);
                carouselRegister.called = false;
                carouselRegister.block = false;
            }).catch((error) => {
                carouselRegister.setPercentage(0);
                carouselRegister.setError(true);
                carouselRegister.called = false;
                carouselRegister.block = false;
            });
        }
    }

    static remove(){
        carouselRegister.setPercentage(0);
        carouselRegister.carousel = null;
        carouselRegister.setError(false);
        if(carouselRegister.called){
            carouselRegister.block = true;
            carouselRegister.called = false;
        }
        try {
            sessionStorage.removeItem('carousel');
        }catch (e) {}
    }


}

export {carouselRegister}


// WEBPACK FOOTER //
// ./src/services/carouselRegister.js